module.exports = {"host":{"prodHosttest":"https://hangzhi.kuaizju.com/prod-api","prodHost":"/prod-api","devHost":"/prod-api"}}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 30